import { React } from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

function TrendingTopics() {

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 960);
    };

    handleResize();

    window.addEventListener('resize', handleResize);


    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const trendingTopics = [
    { title: 'Loan Documentation |', path: "/support/loan-document" },
    { title: 'Pre-Approval Process |', path: '/support/pre-approval-process' },
    { title: 'Credit Scores |', path: '/support/credit-scores' },
    { title: 'Down Payment Strategies', path: '/support/down-payment-strategies' },
  ];



  return (
    // <Grid container lg={12} ml={isMobile ? 1 : 10} mr={isMobile ? 3 : 8} mt={2} mb={2} >
    <Grid container xs={12} marginRight={isMobile ? 2 : 12} >

      <Box
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        sx={{
          gap: '10px', // gap property should be applied using sx
        }}

      >
        <Typography className="topic" sx={{ fontSize: isMobile ? '32px' : '24px', fontWeight: 700, fontFamily: 'Inter' }}>
          Trending Topics:
        </Typography>

        {trendingTopics.map((topic, index) => (
          <Link key={index} to={topic.path} className="topic-link">
            <Typography className="topic" sx={{ fontSize: isMobile ? '22px' : '22px', fontWeight: 500, fontFamily: 'Inter', color: '#31B9B5' }}>
              {topic.title}
            </Typography>
          </Link>
        ))}

      </Box>

    </Grid>

  );
}

export default TrendingTopics;
